export default [
  {
    path: '/admin-dashboard-komchat',
    name: 'admin-dashboard-komchat',
    component: () => import('@/views/pages/komchat/index.vue'),
    meta: {
      resource: 'Komchat - Partner',
      navActiveLink: 'Komchat',
      action: 'manage',
    },
  },
  {
    path: '/partner-komchat',
    name: 'partner-komchat',
    component: () => import('@/views/pages/komchat/partner/index.vue'),
    meta: {
      resource: 'Komchat - Partner',
      navActiveLink: 'Komchat',
      action: 'manage',
    },
  },
  {
    path: '/partner-komchat/:id',
    name: 'partner-komchat-detail',
    component: () => import('@/views/pages/komchat/partner/Detail.vue'),
    meta: {
      resource: 'Komchat - Partner',
      navActiveLink: 'Komchat',
      action: 'manage',
    },
  },
]
